module.exports = __webpack_public_path__ + "img/search-icon.f3dc86f.svg";